/* Getting the language code from the html tag. */
let code = document.documentElement.lang;

import i18n from "../../i18n";
import store from "../../store.js";
i18n.locale = store.state.Language == "" ? code : store.state.Language;
// 

/* It imports the extend and localize functions from the vee-validate package. */
import {
    extend,
    localize,
} from "vee-validate";

/* Importing the language files for the vee-validate package. */
import en from 'vee-validate/dist/locale/en.json';
import es from 'vee-validate/dist/locale/es.json';

/* It imports the required and email rules from the vee-validate package. */
import { required, email, length, numeric, min, max, confirmed } from "vee-validate/dist/rules";

/* Loading the locale file for the language that is set in the html tag. */
if (code == 'es') {
    localize('es', es);
} else {
    localize('en', en);
}

/* Extending the email rule. */
// extend("email", email);
extend("email", {
    ...email,
    message: i18n.t("vee_validate.email")
});

/* Extending the required rule. */
extend("required", { ...required, message: i18n.t("vee_validate.required") });

/* Extending the length rule. */
extend("length", { ...length, message: i18n.t("vee_validate.length") });

/* Extending the numeric rule. */
extend("numeric", { ...numeric, message: i18n.t("vee_validate.numeric") });

/* Extending the min rule. */
extend("min", { ...min, message: i18n.t("vee_validate.min") });

/* Extending the max rule. */
extend("max", { ...max, message: i18n.t("vee_validate.max") });

/* Extending the confirmed rule. */
extend("confirmed", {
    ...confirmed,
    message: i18n.t("vee_validate.confirmed"),
});

/* La contraseña debe contener al menos una letra mayúscula */
extend('uppercase', {
    validate: value => /[A-Z]/.test(value),
    message: i18n.t("Validations.password_uppercase_letters")  // Mensaje de i18n para letras mayúsculas
});

/* La contraseña debe contener al menos una letra minúscula */
extend('lowercase', {
    validate: value => /[a-z]/.test(value),
    message: i18n.t("Validations.password_lowercase_letters")  // Mensaje de i18n para letras minúsculas
});

/* La contraseña debe contener al menos un número */
extend("containsNumber", {
    validate: (value) => /[0-9]/.test(value),
    message: i18n.t("Validations.password_numeric_characters"), // Mensaje de i18n para números
});

/* La contraseña debe incluir caracteres especiales (!, $, #, %) */
extend("specialChars", {
    validate: (value) => /[!$#%]/.test(value),
    message: i18n.t("Validations.password_special_characters"), // Mensaje de i18n para caracteres especiales
});